var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"append-icon":_vm.icon,"box":"","disabled":_vm.disabled,"hide-details":"","label":"Expiration","mask":"## / ##","type":"tel","required":_vm.required,"return-masked-value":"","rules":_vm.rules},model:{value:(_vm.cardExpiration),callback:function ($$v) {_vm.cardExpiration=$$v},expression:"cardExpiration"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-312067d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/CardExpiration.vue
// module id = null
// module chunks = 